<template>
  <div>
    <div
        v-if="showComponent && !disabled"
        :title="qaAble ? showIfHasPermission?.toString() : null"
        :key="componentRefresh"
    >
      <router-link v-if="path" class="dropdown-item" :to="path">
        <i :class="[classIcon]" v-if="classIcon"/> {{ label }}
      </router-link>
      <div v-else class="dropdown-item pointer" @click.prevent="$emit('onClick')">
        <i :class="[classIcon]" v-if="classIcon"/> {{ label }}
      </div>
      <slot/>
    </div>
    <!--  <div v-else style="opacity: .5; padding: .25rem 1.5rem;" :title="title">
        <i :class="[classIcon]" v-if="classIcon"/> {{ label }}
      </div>-->
    <div
        v-if="showComponent && disabled"
        style="opacity: .5; padding: .25rem 1.5rem;"
    >
      <ks-popover
          hoverText="No Employer is Selected"
          :iconValue="classIcon"
          :abbreviated="false"
          :value="label"
          placement="left"
      />
    </div>
    <!--    {{showComponent}}
        {{disabled}}
        {{classIcon}}
        {{label}}-->
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name:     "dropdown-item",
  mixins:   [checkPermissions],
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  props:    {
    disabled:  {type: Boolean, default: false},
    label:     {
      type:     String,
      required: false
    },
    path:      {
      type:     String,
      required: false,
      default:  null
    },
    classIcon: {
      type:    String,
      default: null
    },
    title:     {
      type:    String,
      default: null
    }
  }
}
</script>
<style>
.pointer {
  cursor: pointer;
}
</style>
